function setStateCookie(state) {
    const cookieName = 'rb_course_session_state';
    document.cookie = `${cookieName}=${state}; path=/;`;
}

function getStateCookie() {
    const cookieName = 'rb_course_session_state';
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        let currentCookie = cookieArray[i].trim();
        if (currentCookie.indexOf(name) == 0) {
            return currentCookie.substring(name.length);
        }
    }

    return '';
}
